// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Email Verification flow — fully scoped */

.ev-page {
  width: 100%;
  min-height: 100%;
  padding: 35px 0;
  max-width: 1150px;
  margin: 0 auto;
}

.ev-page *,
.ev-page *::before,
.ev-page *::after {
  box-sizing: border-box;
}

.ev-page__crumbs {
  margin-bottom: 18px;
}

.ev-page__crumbList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8e939c;
  font-size: 15px;
  font-weight: 500;
}

.ev-page__crumbItem--active {
  color: #ebebeb;
  font-weight: 700;
}

body.light_theme .ev-page__crumbItem--active {
  color: #101828;
}

.ev-page__crumbSep {
  color: #8e939c;
}

.ev-page__crumbLink {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.ev-page__crumbLink:hover {
  color: #dfdfdf;
  text-decoration: underline;
  text-underline-offset: 3px;
}

body.light_theme .ev-page__crumbLink:hover {
  color: #101828;
}

.email_verification_lft {
  padding-top: 40px;
  padding-left: 30px;
}

.ev-page__title {
  margin: 0 0 10px;
  font-size: 36px;
  font-weight: 600;
  color: #e3e3e3;
}

body.light_theme .ev-page__title {
  color: #101828;
}

.ev-page__subtitle {
  margin: 0 0 22px;
  font-size: 14px;
  line-height: 1.55;
  color: #8e939c;
  font-weight: 500;
  max-width: 660px;
}

.ev-page__learn {
  font-weight: 600;
  color: #e3e3e3;
}

body.light_theme .ev-page__learn {
  color: #101828;
}

.ev-card {
  width: 100%;
  border-radius: 10px;
  background: #ffffff0d;
  border: 1px solid #ffffff33;
  padding: 23px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 35px;
}

body.light_theme .ev-card {
  background: #F5F6F7;
  border: 1px solid #F5F6F7;
}

.ev-card__left {
  display: flex;
  align-items: start;
  gap: 12px;
}

.ev-card__icon {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ev-card__icon img {
  width: 22px;
  height: 22px;
  display: block;
}

.ev-card__email {
  font-size: 16px;
  font-weight: 500;
  color: #e2e2e2;
}

body.light_theme .ev-card__email {
  color: #101828;
}

.ev-card__meta {
  font-size: 12px;
  font-weight: 500;
  color: #d7d7d7;
  margin-top: 3px;
}

.ev-card__left img {
  filter: invert(1);
}

body.light_theme .ev-card__left img {
  filter: invert(0);
}

body.light_theme .ev-card__meta {
  color: #8e939c;
}

.ev-card__edit {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
}

/* .ev-card__edit:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
} */

/* Shared modal base (reuse typography vibe from other popups) */
.ev-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000020;
}

body.light_theme .ev-modal-overlay {
  background: rgb(255 255 255 / 20%);
}

.ev-modal__actions button.ev-btn.ev-btn--primary {
  width: 100%;
}

.ev-modal {
  width: 628px;
  max-width: 92vw;
  border-radius: 20px;
  background: rgb(50 50 50 / 20%);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50);
  padding: 26px 26px 22px;
  position: relative;
  text-align: center;
}

body.light_theme .ev-modal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #eef2f6;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
}

.ev-modal__close {
  position: absolute;
  top: 16px;
  right: 18px;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  color: #84888C;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease, color 0.15s ease;
}

.ev-modal__close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

body.light_theme .ev-modal__close {
  color: #111827;
}

body.light_theme .ev-modal__close:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
}

.ev-modal__art {
  width: 186px;
  margin: 6px auto 30px;
}

.ev-modal__art img {
  display: block;
  width: 100%;
  height: auto;
}

.ev-modal__title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #ffffff;
}

body.light_theme .ev-modal__title {
  color: #111827;
}

.ev-modal__subtitle {
  margin: 12px auto 16px;
  max-width: 520px;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.55;
  color: #84888C;
}

body.light_theme .ev-modal__subtitle {
  color: #6A7282;
}

.ev-warnBox {
  width: 505px;
  max-width: 100%;
  text-align: left;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 11px;
  padding: 16px 18px;
  margin: 10px auto 18px;
}

body.light_theme .ev-warnBox {
  border: 1px solid #E4E4E4;
}

.ev-warnRow {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #84888C !important;
  line-height: 1.45;
}

body.light_theme .ev-warnRow {
  color: #6b7280 !important;
}

.ev-warnRow input {
  margin-top: 2px;
  accent-color: #d1aa67;
}

body.light_theme .ev-warnRow input {
  accent-color: #303236;
}

.ev-modal__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 26px;
  padding: 0px 30px;
}

.ev-modal.ev-change-modal {
  width: 539px;
}

.ev-btn {
  height: 46px;
  border-radius: 999px;
  border: none;
  padding: 0 22px;
  width: 150px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.ev-btn--ghost {
  background: #2b3139;
  color: #eaecef;
}

.ev-btn--ghost:hover {
  background: #3a414b;
}

body.light_theme .ev-btn--ghost {
  background: #DDDDDD;
  color: #6b7280;
}

body.light_theme .ev-btn--ghost:hover {
  background: #d0d0d0;
}

.ev-btn--primary {
  background: #d1aa67;
  color: #0c0d10;
  font-weight: 700;
}

.ev-btn--primary:hover:not(:disabled) {
  background: rgb(175, 145, 25);
}

body.light_theme .ev-btn--primary {
  background: #303236;
  color: #fff;
  font-weight: 500;
}

body.light_theme .ev-btn--primary:hover:not(:disabled) {
  background: #1a1b1f;
}

.ev-btn--primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Change Email modal */
.ev-change-modal {
  text-align: left;
  padding: 22px 22px 22px;
}

.ev-change-modal__title {
  margin: 0;
  padding-right: 44px;
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
}

body.light_theme .ev-change-modal__title {
  color: #111827;
}

.ev-change-modal__subtitle {
  margin: 13px 0 20px;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.45;
  color: #84888C;
}

body.light_theme .ev-change-modal__subtitle {
  color: #6A7282;
}

.ev-change-field {
  margin-top: 18px;
}

.ev-change-labelRow {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.ev-change-label {
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: -0.45px;
  margin-bottom: 6px;
  display: block;
}

body.light_theme .ev-change-label {
  color: #111827;
}

.ev-change-field .ev-change-labelRow {
  height: 48px;
  background-color: #1e2329;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  align-items: center;
  padding-right: 17px;
}

body.light_theme .ev-change-field .ev-change-labelRow {
  border: 1px solid #e5e7eb;
  background-color: #fff;
}

.ev-change-labelRow .ev-change-input {
  height: 100%;
  border: none;
}

.ev-change-get {
  white-space: nowrap;
}

.ev-change-get {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  color: #d1aa67;
  cursor: pointer;
  transition: color 0.15s ease;
}

.ev-change-get:hover {
  color: #bb924b;
}

body.light_theme .ev-change-get {
  color: #AC8A50;
}

body.light_theme .ev-change-get:hover {
  color: #b08d52;
}

.ev-change-input {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: #1e2329;
  padding: 0 14px;
  font-size: 13px;
  font-weight: 500;
  color: #ffffff;
  outline: none;
}

body.light_theme .ev-change-input {
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #111827;
}

.ev-change-submit {
  width: 100%;
  height: 48px;
  margin-top: 28px;
  border: none;
  border-radius: 999px;
  background: #d1aa67;
  color: #0c0d10;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}

.ev-change-submit:hover {
  background: #c29b57;
}

body.light_theme .ev-change-submit {
  background: #2d2e32;
  color: #fff;
  font-weight: 500;
}

body.light_theme .ev-change-submit:hover {
  background: #1a1b1f;
}

@media (max-width: 767px) {

  .ev-modal-overlay {
    align-items: end;
  }

  .ev-warnRow {
    font-size: 12px;
  }

  .ev-btn {
    height: 38px;
  }

  .ev-modal {
    width: 100%;
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
    height: 60vh;
    overflow: scroll;
  }

  .ev-page {
    padding: 30px 16px 20px;
  }

  .ev-page__title {
    font-size: 20px;
  }

  .ev-card {
    padding: 20px;
    margin-top: 18px;
  }

  .ev-modal {
    padding: 20px 16px 16px;
  }

  .ev-modal__title {
    margin: 0;
    font-size: 20px;
  }

  .email_verification_lft {
    padding-top: 10px;
    padding-left: 0px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/emailVerification.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;;;GAGG;;AAEH,gEAAgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;EAClC,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;AAEF","sourcesContent":["/* Email Verification flow — fully scoped */\n\n.ev-page {\n  width: 100%;\n  min-height: 100%;\n  padding: 35px 0;\n  max-width: 1150px;\n  margin: 0 auto;\n}\n\n.ev-page *,\n.ev-page *::before,\n.ev-page *::after {\n  box-sizing: border-box;\n}\n\n.ev-page__crumbs {\n  margin-bottom: 18px;\n}\n\n.ev-page__crumbList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #8e939c;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.ev-page__crumbItem--active {\n  color: #ebebeb;\n  font-weight: 700;\n}\n\nbody.light_theme .ev-page__crumbItem--active {\n  color: #101828;\n}\n\n.ev-page__crumbSep {\n  color: #8e939c;\n}\n\n.ev-page__crumbLink {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.ev-page__crumbLink:hover {\n  color: #dfdfdf;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\nbody.light_theme .ev-page__crumbLink:hover {\n  color: #101828;\n}\n\n.email_verification_lft {\n  padding-top: 40px;\n  padding-left: 30px;\n}\n\n.ev-page__title {\n  margin: 0 0 10px;\n  font-size: 36px;\n  font-weight: 600;\n  color: #e3e3e3;\n}\n\nbody.light_theme .ev-page__title {\n  color: #101828;\n}\n\n.ev-page__subtitle {\n  margin: 0 0 22px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #8e939c;\n  font-weight: 500;\n  max-width: 660px;\n}\n\n.ev-page__learn {\n  font-weight: 600;\n  color: #e3e3e3;\n}\n\nbody.light_theme .ev-page__learn {\n  color: #101828;\n}\n\n.ev-card {\n  width: 100%;\n  border-radius: 10px;\n  background: #ffffff0d;\n  border: 1px solid #ffffff33;\n  padding: 23px 25px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 35px;\n}\n\nbody.light_theme .ev-card {\n  background: #F5F6F7;\n  border: 1px solid #F5F6F7;\n}\n\n.ev-card__left {\n  display: flex;\n  align-items: start;\n  gap: 12px;\n}\n\n.ev-card__icon {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ev-card__icon img {\n  width: 22px;\n  height: 22px;\n  display: block;\n}\n\n.ev-card__email {\n  font-size: 16px;\n  font-weight: 500;\n  color: #e2e2e2;\n}\n\nbody.light_theme .ev-card__email {\n  color: #101828;\n}\n\n.ev-card__meta {\n  font-size: 12px;\n  font-weight: 500;\n  color: #d7d7d7;\n  margin-top: 3px;\n}\n\n.ev-card__left img {\n  filter: invert(1);\n}\n\nbody.light_theme .ev-card__left img {\n  filter: invert(0);\n}\n\nbody.light_theme .ev-card__meta {\n  color: #8e939c;\n}\n\n.ev-card__edit {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n}\n\n/* .ev-card__edit:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n} */\n\n/* Shared modal base (reuse typography vibe from other popups) */\n.ev-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100000020;\n}\n\nbody.light_theme .ev-modal-overlay {\n  background: rgb(255 255 255 / 20%);\n}\n\n.ev-modal__actions button.ev-btn.ev-btn--primary {\n  width: 100%;\n}\n\n.ev-modal {\n  width: 628px;\n  max-width: 92vw;\n  border-radius: 20px;\n  background: rgb(50 50 50 / 20%);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50);\n  padding: 26px 26px 22px;\n  position: relative;\n  text-align: center;\n}\n\nbody.light_theme .ev-modal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #eef2f6;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);\n}\n\n.ev-modal__close {\n  position: absolute;\n  top: 16px;\n  right: 18px;\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: transparent;\n  color: #84888C;\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 10px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.ev-modal__close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\nbody.light_theme .ev-modal__close {\n  color: #111827;\n}\n\nbody.light_theme .ev-modal__close:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n}\n\n.ev-modal__art {\n  width: 186px;\n  margin: 6px auto 30px;\n}\n\n.ev-modal__art img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.ev-modal__title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #ffffff;\n}\n\nbody.light_theme .ev-modal__title {\n  color: #111827;\n}\n\n.ev-modal__subtitle {\n  margin: 12px auto 16px;\n  max-width: 520px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #84888C;\n}\n\nbody.light_theme .ev-modal__subtitle {\n  color: #6A7282;\n}\n\n.ev-warnBox {\n  width: 505px;\n  max-width: 100%;\n  text-align: left;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 11px;\n  padding: 16px 18px;\n  margin: 10px auto 18px;\n}\n\nbody.light_theme .ev-warnBox {\n  border: 1px solid #E4E4E4;\n}\n\n.ev-warnRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #84888C !important;\n  line-height: 1.45;\n}\n\nbody.light_theme .ev-warnRow {\n  color: #6b7280 !important;\n}\n\n.ev-warnRow input {\n  margin-top: 2px;\n  accent-color: #d1aa67;\n}\n\nbody.light_theme .ev-warnRow input {\n  accent-color: #303236;\n}\n\n.ev-modal__actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 26px;\n  padding: 0px 30px;\n}\n\n.ev-modal.ev-change-modal {\n  width: 539px;\n}\n\n.ev-btn {\n  height: 46px;\n  border-radius: 999px;\n  border: none;\n  padding: 0 22px;\n  width: 150px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.ev-btn--ghost {\n  background: #2b3139;\n  color: #eaecef;\n}\n\n.ev-btn--ghost:hover {\n  background: #3a414b;\n}\n\nbody.light_theme .ev-btn--ghost {\n  background: #DDDDDD;\n  color: #6b7280;\n}\n\nbody.light_theme .ev-btn--ghost:hover {\n  background: #d0d0d0;\n}\n\n.ev-btn--primary {\n  background: #d1aa67;\n  color: #0c0d10;\n  font-weight: 700;\n}\n\n.ev-btn--primary:hover:not(:disabled) {\n  background: rgb(175, 145, 25);\n}\n\nbody.light_theme .ev-btn--primary {\n  background: #303236;\n  color: #fff;\n  font-weight: 500;\n}\n\nbody.light_theme .ev-btn--primary:hover:not(:disabled) {\n  background: #1a1b1f;\n}\n\n.ev-btn--primary:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* Change Email modal */\n.ev-change-modal {\n  text-align: left;\n  padding: 22px 22px 22px;\n}\n\n.ev-change-modal__title {\n  margin: 0;\n  padding-right: 44px;\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\nbody.light_theme .ev-change-modal__title {\n  color: #111827;\n}\n\n.ev-change-modal__subtitle {\n  margin: 13px 0 20px;\n  font-size: 17px;\n  font-weight: 500;\n  line-height: 1.45;\n  color: #84888C;\n}\n\nbody.light_theme .ev-change-modal__subtitle {\n  color: #6A7282;\n}\n\n.ev-change-field {\n  margin-top: 18px;\n}\n\n.ev-change-labelRow {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.ev-change-label {\n  font-size: 18px;\n  font-weight: 500;\n  color: #ffffff;\n  letter-spacing: -0.45px;\n  margin-bottom: 6px;\n  display: block;\n}\n\nbody.light_theme .ev-change-label {\n  color: #111827;\n}\n\n.ev-change-field .ev-change-labelRow {\n  height: 48px;\n  background-color: #1e2329;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  align-items: center;\n  padding-right: 17px;\n}\n\nbody.light_theme .ev-change-field .ev-change-labelRow {\n  border: 1px solid #e5e7eb;\n  background-color: #fff;\n}\n\n.ev-change-labelRow .ev-change-input {\n  height: 100%;\n  border: none;\n}\n\n.ev-change-get {\n  white-space: nowrap;\n}\n\n.ev-change-get {\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #d1aa67;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.ev-change-get:hover {\n  color: #bb924b;\n}\n\nbody.light_theme .ev-change-get {\n  color: #AC8A50;\n}\n\nbody.light_theme .ev-change-get:hover {\n  color: #b08d52;\n}\n\n.ev-change-input {\n  width: 100%;\n  height: 48px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: #1e2329;\n  padding: 0 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #ffffff;\n  outline: none;\n}\n\nbody.light_theme .ev-change-input {\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #111827;\n}\n\n.ev-change-submit {\n  width: 100%;\n  height: 48px;\n  margin-top: 28px;\n  border: none;\n  border-radius: 999px;\n  background: #d1aa67;\n  color: #0c0d10;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.ev-change-submit:hover {\n  background: #c29b57;\n}\n\nbody.light_theme .ev-change-submit {\n  background: #2d2e32;\n  color: #fff;\n  font-weight: 500;\n}\n\nbody.light_theme .ev-change-submit:hover {\n  background: #1a1b1f;\n}\n\n@media (max-width: 767px) {\n\n  .ev-modal-overlay {\n    align-items: end;\n  }\n\n  .ev-warnRow {\n    font-size: 12px;\n  }\n\n  .ev-btn {\n    height: 38px;\n  }\n\n  .ev-modal {\n    width: 100%;\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n    height: 60vh;\n    overflow: scroll;\n  }\n\n  .ev-page {\n    padding: 30px 16px 20px;\n  }\n\n  .ev-page__title {\n    font-size: 20px;\n  }\n\n  .ev-card {\n    padding: 20px;\n    margin-top: 18px;\n  }\n\n  .ev-modal {\n    padding: 20px 16px 16px;\n  }\n\n  .ev-modal__title {\n    margin: 0;\n    font-size: 20px;\n  }\n\n  .email_verification_lft {\n    padding-top: 10px;\n    padding-left: 0px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
